var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinesPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 430,
    height: 1228,
    viewBox: "0 0 430 1228",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_253_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.204 1000.74C299.418 991.444 356.873 947.746 358.381 886.81C360.27 810.531 273.729 738.486 200.914 709.113C141.142 685.008 117.536 700.512 83.7833 669.855C42.8821 632.713 62.4272 563.197 76.0971 508.739C90.4731 451.415 91.5168 452.433 121.238 381.361C130.321 359.639 157.763 294.029 139.378 242.97C109.172 159.055 -44.0135 116.459 -157.762 143.74C-360.81 192.446 -509.581 480.987 -438.673 701.158C-402.302 814.094 -318.487 876.897 -261.567 919.544C-102.11 1039.01 149.758 1105.27 287.197 1000.75L287.204 1000.74Z",
    stroke: "url(#paint0_linear_253_3)",
    strokeWidth: 7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.295 984.945C274.621 975.732 327.59 934.457 328.022 876.821C328.376 829.359 292.774 783.507 248.208 749.476C225.252 731.946 200.116 717.657 176.54 708.029C119.529 684.688 96.9255 698.808 65.2311 669.612C59.1142 663.982 54.4741 657.609 51.0268 650.712C33.8433 616.34 45.6635 568.009 56.2664 527.04C57.2404 523.291 58.2288 519.596 59.1796 515.985C73.6122 461.459 75.4631 462.516 103.495 395.326C112.077 374.729 137.734 312.926 120.33 264.753C91.7126 185.55 -52.4581 145.312 -159.76 170.419C-352.612 215.54 -497.415 489.157 -431.362 699.565C-397.502 807.716 -317.596 868.867 -262.313 910.582C-172.18 978.507 -51.2818 1028.34 59.0943 1036.63C137.301 1042.39 210.999 1027.53 263.296 984.96L263.295 984.945Z",
    stroke: "url(#paint1_linear_253_3)",
    strokeWidth: 6.61,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.379 969.159C249.822 960.004 298.308 921.183 297.657 866.84C297.129 822.234 263.161 779.014 220.427 746.552C198.461 729.856 174.538 716.208 152.165 706.944C97.9178 684.384 76.315 697.104 46.6631 669.372C40.8476 663.935 36.5094 657.829 33.3089 651.268C17.147 618.195 29.1062 572.088 39.3491 533.689C40.2986 530.134 41.2869 526.638 42.2357 523.21C56.6235 471.431 59.3986 472.576 85.7346 409.277C93.8223 389.796 117.687 331.809 101.257 286.53C74.2283 212.04 -60.9184 174.167 -161.789 197.103C-344.445 238.638 -485.287 497.34 -424.081 697.99C-392.732 801.357 -316.726 860.863 -263.096 901.648C-176.281 967.477 -59.6628 1015.4 45.7881 1022.19C120.78 1026.78 191.667 1011 239.358 969.185L239.379 969.159Z",
    stroke: "url(#paint2_linear_253_3)",
    strokeWidth: 6.22,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.454 953.366C225.021 944.261 269.011 907.911 267.283 856.853C265.865 815.111 233.538 774.515 192.629 743.614C171.643 727.746 148.958 714.744 127.789 705.844C76.2961 684.058 55.694 695.378 28.109 669.114C22.6036 663.878 18.5586 658.031 15.598 651.814C0.46464 620.033 12.5558 576.159 22.4456 540.322C23.3775 536.951 24.3657 533.654 25.3145 530.425C39.7081 481.419 43.3412 482.627 67.995 423.202C75.5815 404.846 97.6514 350.658 82.2199 308.28C56.7735 238.511 -69.3529 202.971 -163.791 223.751C-336.267 261.703 -473.125 505.479 -416.78 696.374C-387.943 794.957 -315.844 852.826 -263.852 892.664C-180.347 956.403 -68.0299 1002.65 32.5078 1007.69C104.266 1011.29 172.384 994.358 215.454 953.366Z",
    stroke: "url(#paint3_linear_253_3)",
    strokeWidth: 5.83,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.545 937.571C200.25 928.498 239.741 894.66 236.915 846.856C234.627 807.992 203.907 770.009 164.83 740.675C144.826 725.635 123.362 713.282 103.397 704.745C54.6656 683.724 35.0799 693.643 9.53918 668.857C4.34207 663.807 0.592148 658.234 -2.12173 652.354C-16.2196 621.854 -3.99638 580.214 5.53525 546.963C6.44261 543.786 7.43954 540.694 8.38633 537.648C22.7927 491.406 27.2856 492.694 50.2503 437.151C57.3426 419.912 77.62 369.539 63.1626 330.055C39.2962 264.992 -77.8238 231.803 -165.804 250.432C-328.102 284.786 -460.982 513.659 -409.485 694.782C-383.159 788.58 -314.968 844.798 -264.614 883.704C-184.427 945.346 -76.3982 989.759 19.2225 993.218C87.7564 995.704 153.094 977.65 191.536 937.564L191.545 937.571Z",
    stroke: "url(#paint4_linear_253_3)",
    strokeWidth: 5.44,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.629 921.785C175.483 912.711 210.47 881.408 206.55 836.876C203.383 800.899 174.294 765.517 137.049 737.751C118.034 723.546 97.7742 711.882 79.0224 703.661C33.01 683.513 14.4902 691.913 -9.02188 668.608C-13.9176 663.753 -17.3586 658.436 -19.8326 652.9C-32.8951 623.683 -20.5154 584.281 -11.3683 553.595C-10.4785 550.603 -9.48166 547.71 -8.54184 544.871C5.8792 501.409 11.23 502.761 32.4968 451.093C39.0967 434.986 57.5867 388.405 44.1121 351.822C21.8345 291.471 -86.2809 260.618 -167.804 277.097C-319.939 307.853 -448.44 521.713 -402.174 693.189C-378.166 782.156 -314.069 836.774 -265.367 874.751C-188.498 934.296 -84.7422 976.87 5.93893 978.762C71.2464 980.117 133.802 960.856 167.629 921.785Z",
    stroke: "url(#paint5_linear_253_3)",
    strokeWidth: 5.05,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.704 905.992C150.706 896.902 181.194 868.182 176.176 826.888C172.154 793.803 144.663 761.011 109.25 734.813C91.2099 721.444 72.1784 710.42 54.6392 702.569C11.3744 683.204 -6.11703 690.169 -27.5829 668.359C-32.1773 663.697 -35.3164 658.647 -37.5505 653.456C-49.5775 625.521 -37.0413 588.356 -28.2856 560.245C-27.4116 557.454 -26.4236 554.752 -25.4769 552.103C-11.0362 511.396 -4.84133 512.829 14.7452 465.051C20.8509 450.061 37.5484 407.294 25.0478 373.607C4.35209 317.977 -94.7694 289.437 -169.824 303.787C-311.815 330.932 -436.243 529.879 -394.886 691.606C-373.358 775.784 -313.207 828.764 -266.136 865.799C-192.577 923.255 -93.1036 963.968 -7.35331 964.298C54.7366 964.53 114.477 943.922 143.704 905.992Z",
    stroke: "url(#paint6_linear_253_3)",
    strokeWidth: 4.66,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.795 890.197C125.957 881.057 151.959 854.958 145.815 816.883C140.949 786.697 115.054 756.494 81.4654 731.857C64.4061 719.316 46.5983 708.955 30.2609 701.454C-10.2473 682.877 -26.6967 688.39 -46.139 668.085C-50.4163 663.616 -53.2622 658.824 -55.2564 653.978C-66.2342 627.307 -53.5466 592.406 -45.1753 566.86C-44.3189 564.253 -43.3222 561.757 -42.3844 559.3C-27.9222 521.364 -20.8694 522.861 -2.98769 478.967C2.61686 465.102 17.5288 426.142 6.0023 395.349C-13.1046 344.432 -103.241 318.197 -171.834 330.428C-303.698 353.949 -424.041 538.021 -387.586 689.99C-368.547 769.373 -312.394 820.814 -266.893 856.815C-196.762 912.314 -101.462 951.025 -20.6337 949.801C38.2386 948.91 95.1064 926.811 119.8 890.173L119.795 890.197Z",
    stroke: "url(#paint7_linear_253_3)",
    strokeWidth: 4.27,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8791 874.411C101.188 865.183 122.727 841.766 115.45 806.902C109.756 779.629 85.4337 752.011 53.6775 728.942C37.5992 717.229 21.022 707.523 5.87959 700.378C-31.8809 682.584 -47.2744 686.627 -64.7069 667.844C-68.676 663.561 -71.2199 659.035 -72.9811 654.542C-82.9096 629.136 -70.048 596.486 -62.0995 573.518C-61.2676 571.106 -60.264 568.8 -59.3332 566.55C-44.8337 531.383 -36.9544 532.947 -20.7461 492.934C-15.6427 480.194 -2.51633 445.04 -13.0531 417.141C-30.5713 370.936 -111.733 346.985 -173.839 357.117C-295.601 376.992 -411.842 546.203 -380.282 688.405C-363.729 763.009 -311.517 812.802 -267.653 847.87C-200.847 901.282 -109.808 938.121 -33.9171 935.344C21.7357 933.314 75.643 909.584 95.8842 874.387L95.8791 874.411Z",
    stroke: "url(#paint8_linear_253_3)",
    strokeWidth: 3.88,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9632 858.625C76.4067 849.27 93.5303 828.601 85.0843 796.922C78.589 772.582 55.8114 747.512 25.8876 726.011C10.7992 715.132 -4.56496 706.067 -18.4949 699.293C-53.4921 682.279 -67.8316 684.837 -83.2661 667.611C-86.9338 663.521 -89.1688 659.252 -90.6814 655.111C-99.5538 630.961 -86.5007 600.577 -78.9836 580.18C-78.1605 577.959 -77.1727 575.854 -76.2438 573.787C-61.7072 541.389 -52.9173 543.059 -38.4821 506.89C-33.8485 495.271 -22.539 463.928 -32.1017 438.924C-48.038 397.44 -120.238 375.733 -175.843 383.805C-287.531 400.014 -399.658 554.386 -372.985 686.829C-358.928 756.647 -310.638 804.805 -268.413 838.926C-204.925 890.241 -118.157 925.185 -47.2075 920.896C5.23269 917.718 56.0336 892.2 71.9613 858.609L71.9632 858.625Z",
    stroke: "url(#paint9_linear_253_3)",
    strokeWidth: 3.48,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.0384 842.832C51.5639 833.309 64.3668 815.448 54.7101 786.934C47.4622 765.537 26.189 743.013 -1.90224 723.079C-16.0096 713.029 -30.152 704.611 -42.8782 698.201C-75.1207 681.962 -88.3836 683.023 -101.827 667.361C-105.18 663.449 -107.113 659.445 -108.399 655.666C-116.193 632.762 -102.953 604.668 -95.9008 586.83C-95.0954 584.794 -94.0989 582.894 -93.1789 581.019C-78.5894 551.388 -68.9729 553.125 -56.2424 520.841C-52.1012 510.354 -42.5792 482.802 -51.1591 460.699C-65.5153 423.921 -128.755 404.444 -177.857 410.487C-279.505 423.002 -387.491 562.572 -365.688 685.252C-354.133 750.293 -309.761 796.792 -269.173 829.981C-208.994 879.206 -126.507 912.249 -60.4911 906.439C-11.2722 902.107 36.2606 874.644 48.0541 842.83L48.0384 842.832Z",
    stroke: "url(#paint10_linear_253_3)",
    strokeWidth: 3.09,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1294 827.038C26.693 817.312 35.2747 802.295 24.3428 776.938C16.3895 758.479 -3.42641 738.505 -29.7009 720.142C-42.834 710.927 -55.739 703.156 -67.2615 697.11C-96.7494 681.644 -108.906 681.189 -120.397 667.105C-123.45 663.371 -125.065 659.632 -126.119 656.206C-132.82 634.529 -119.37 608.73 -112.813 593.455C-112.017 591.611 -111.02 589.91 -110.116 588.236C-95.4578 561.37 -85.0373 563.186 -73.9959 534.784C-70.3489 525.413 -62.6194 501.676 -70.2253 482.468C-82.9927 450.403 -137.311 433.096 -179.888 437.155C-271.537 445.901 -375.356 570.746 -358.41 683.647C-349.358 743.91 -308.894 788.757 -269.959 821.017C-213.092 868.136 -134.878 899.268 -73.8009 891.961C-27.7896 886.457 16.2252 856.954 24.1118 827.024L24.1294 827.038Z",
    stroke: "url(#paint11_linear_253_3)",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.213437 811.251C1.72617 801.311 6.26285 789.147 -6.0226 766.957C-14.6187 751.429 -33.0487 734.006 -57.4907 717.21C-69.634 708.831 -81.319 701.692 -91.6447 696.019C-118.371 681.317 -129.408 679.329 -138.958 666.856C-141.689 663.29 -143.001 659.832 -143.837 656.761C-149.414 636.308 -135.742 612.827 -129.722 600.112C-128.943 598.453 -127.946 596.95 -127.042 595.475C-112.314 571.39 -101.091 573.268 -91.7475 548.741C-88.6016 540.496 -82.6665 520.559 -89.2826 504.244C-100.468 476.899 -145.877 461.669 -181.894 463.827C-263.603 468.718 -363.235 578.937 -351.106 682.062C-344.579 737.559 -308.003 780.727 -270.712 812.063C-217.149 857.068 -143.217 886.283 -87.0775 877.496C-44.2756 870.803 -4.0389 839.211 0.211588 811.236L0.213437 811.251Z",
    stroke: "url(#paint12_linear_253_3)",
    strokeWidth: 2.31,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-23.7025 795.465C-23.366 785.324 -22.6343 775.962 -36.388 756.976C-45.5348 744.351 -62.6691 729.522 -85.2717 714.286C-96.434 706.734 -106.888 700.25 -116.019 694.934C-139.984 680.997 -149.867 677.432 -157.51 666.613C-159.91 663.222 -160.92 660.03 -161.539 657.314C-165.954 638.073 -152.039 616.955 -146.616 606.751C-145.831 605.282 -144.857 603.988 -143.955 602.696C-129.122 581.404 -117.14 583.326 -109.477 562.689C-106.825 555.559 -102.682 539.438 -108.316 526.025C-117.912 503.392 -154.444 490.155 -183.883 490.514C-255.719 491.381 -351.119 587.153 -343.787 680.475C-339.809 731.2 -307.088 772.701 -271.457 803.117C-221.198 846.008 -151.56 873.267 -100.352 863.045C-60.7704 855.143 -24.5657 821.532 -23.7025 795.465Z",
    stroke: "url(#paint13_linear_253_3)",
    strokeWidth: 1.92,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.6204 779.664C-48.5904 769.362 -51.4074 762.62 -66.7554 746.98C-76.3839 737.17 -92.2846 725.015 -113.07 711.348C-123.252 704.624 -132.477 698.779 -140.402 693.842C-161.601 680.647 -170.273 675.506 -176.08 666.357C-178.137 663.108 -178.841 660.212 -179.265 657.863C-182.449 639.817 -168.287 621.093 -163.542 613.394C-162.757 612.123 -161.792 611.022 -160.905 609.93C-145.952 591.445 -133.236 593.39 -127.246 576.633C-125.095 570.629 -122.738 558.314 -127.39 547.787C-135.398 529.867 -163.082 518.459 -185.914 517.182C-247.916 513.696 -339.094 595.34 -336.507 678.886C-335.095 724.84 -306.164 764.612 -272.234 794.159C-225.195 834.846 -159.941 860.208 -113.644 848.582C-77.2934 839.446 -45.3369 804.001 -47.6185 779.679L-47.6204 779.664Z",
    stroke: "url(#paint14_linear_253_3)",
    strokeWidth: 1.53,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-71.5362 763.878C-73.9288 753.508 -80.0775 749.074 -97.1294 736.993C-107.192 729.865 -121.916 720.508 -140.869 708.41C-150.076 702.523 -158.059 697.299 -164.794 692.744C-183.21 680.287 -190.63 673.533 -194.65 666.101C-196.333 662.989 -196.763 660.394 -196.985 658.403C-198.841 641.555 -184.441 625.29 -180.446 620.026C-179.636 618.959 -178.704 618.045 -177.826 617.145C-162.724 601.502 -149.302 603.434 -144.983 590.573C-143.343 585.687 -142.763 577.186 -146.432 569.561C-152.867 556.355 -171.653 546.517 -187.913 543.845C-240.025 535.286 -327.087 603.513 -329.205 677.285C-330.382 718.465 -305.282 756.574 -272.989 785.19C-229.268 823.78 -168.311 847.1 -126.923 834.1C-93.815 823.693 -66.2523 786.726 -71.5293 763.869L-71.5362 763.878Z",
    stroke: "url(#paint15_linear_253_3)",
    strokeWidth: 1.14,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_253_3",
    x1: 372.231,
    y1: 911.721,
    x2: -385.454,
    y2: 316.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_253_3",
    x1: 341.329,
    y1: 902.099,
    x2: -379.115,
    y2: 335.903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_253_3",
    x1: 310.456,
    y1: 892.529,
    x2: -372.816,
    y2: 355.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_253_3",
    x1: 279.645,
    y1: 883.007,
    x2: -366.543,
    y2: 375.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_253_3",
    x1: 248.892,
    y1: 873.573,
    x2: -360.335,
    y2: 394.783,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_253_3",
    x1: 218.229,
    y1: 864.225,
    x2: -354.125,
    y2: 414.413,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_253_3",
    x1: 187.699,
    y1: 854.995,
    x2: -348.027,
    y2: 433.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_253_3",
    x1: 157.697,
    y1: 846.194,
    x2: -341.997,
    y2: 453.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_253_3",
    x1: 128.318,
    y1: 837.883,
    x2: -336.064,
    y2: 472.926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_253_3",
    x1: 99.1669,
    y1: 829.751,
    x2: -330.245,
    y2: 492.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_253_3",
    x1: 70.2195,
    y1: 821.794,
    x2: -324.573,
    y2: 511.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_253_3",
    x1: 41.4896,
    y1: 813.993,
    x2: -319.105,
    y2: 530.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_253_3",
    x1: 13.0071,
    y1: 806.4,
    x2: -313.898,
    y2: 549.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_253_3",
    x1: -15.1264,
    y1: 799.068,
    x2: -309.044,
    y2: 568.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_253_3",
    x1: -42.7813,
    y1: 792.084,
    x2: -304.667,
    y2: 586.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_253_3",
    x1: -69.7857,
    y1: 785.553,
    x2: -300.929,
    y2: 603.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D41E44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#A63B6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#576FB5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 804.471,
    height: 963.672,
    fill: "white",
    transform: "translate(620.777 595.464) rotate(128.164)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinesPhone);
export default __webpack_public_path__ + "static/media/linesPhone.505bb8a59bae96ac6fe345ae7e6015b8.svg";
export { ForwardRef as ReactComponent };